import { render, staticRenderFns } from "./CargoKanban.vue?vue&type=template&id=0d4f5b75&scoped=true"
import script from "./CargoKanban.vue?vue&type=script&lang=js"
export * from "./CargoKanban.vue?vue&type=script&lang=js"
import style0 from "./CargoKanban.vue?vue&type=style&index=0&id=0d4f5b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f5b75",
  null
  
)

export default component.exports